<template>
    <div class="inc_right">
        <div class="listall">
            <!--整體列表-->
            <div :class="table_Class">
                <!--內容列表查無資料物件-->
                <div :class="list_Class" v-if="list.length==0">
                    <div class="hmnewword">
                        {{NotData}}
                    </div>
                </div>
                <!--內容列表物件-->
                <div v-else
                    :class="list_Class" v-for="(item , index) in list" >
                    <a :href="item.url" target="_blank">
                        <div class="hmnewdat">
                            <div class="hmdtex">
                                {{ item.onlineDate }}
                            </div>
                        </div>
                        <div class="hmnewword">
                            {{ item.title }}
                        </div>
                    </a>
                </div>
            </div>
            <!--頁碼-->
            <!-- TODO 動態取得頁碼-->
            <div class="twpage" v-if="list.length>0">
                <div class="navigation">
                <b-pagination
                    class="pagination light-theme simple-pagination"
                    v-model="pagination.page"
                    :total-rows="pagination.rows"
                    :per-page="pagination.perPage"
                    aria-controls="my-table"
                ></b-pagination>
                </div>
            </div> 
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            //列表樣式
            table_Class:"",
            //文章項目樣式
            list_Class:"",
            //無資料時預設文字
            NotData:"",
            //列表資料
            list:[{
                title:"",
                url:"",
                onlineDate:"",
                
            }],
        };
    },
    props:["sideright", "pagination"],
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "sideright.list"(){
            //初始化
            this.init();
        }
    },
    methods:{
        //初始化
        init(){
            this.table_Class=this.sideright.table_Class;
            this.list_Class = this.sideright.list_Class;
            this.list = this.sideright.list;
            
            if(this.sideright && this.sideright.list.length == 1){
                if(this.sideright.list[0].NotData){
                    this.list = [];
                    this.NotData = "目前尚無相關資料，敬請期待！";
                }
            }
        }
    }
}
</script>